import { Components, Theme } from '@mui/material/styles';

export const MuiAppBar: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.palette.studio.shadows.cardFlat,
    }),
  },
  defaultProps: {
    elevation: 0,
    color: 'default',
  },
};
